(function ($) {
    'use strict';

    // Navbar Area
    $(window).on('scroll', function () {

        if ($(this).scrollTop() > 150) {
            $('#navbarSupportedContent > .navbar-brand').removeClass('hideLogo');
            $('.navbar-area').addClass('sticky-nav');
            $('.side-menu').css({'display': 'block'});
        } else {
            $('.navbar-area').removeClass('sticky-nav');
            $('#navbarSupportedContent > .navbar-brand').addClass('hideLogo');
            $('.side-menu').css({'display': 'none'});
        }
    });

    // Search Popup JS
    $('.close-btn').on('click', function () {
        $('.search-overlay').fadeOut();
        $('.search-btn').show();
        $('.close-btn').removeClass('active');
    });
    $('.search-btn').on('click', function () {
        $(this).hide();
        $('.search-overlay').fadeIn();
        $('.close-btn').addClass('active');
    });

    // Sidebar Modal JS
    $('.burger-menu').on('click', function () {
        $('.sidebar-modal').toggleClass('active');
    });
    $('.sidebar-modal-close-btn').on('click', function () {
        $('.sidebar-modal').removeClass('active');
    });

    // Others Option For Responsive JS
    $('.side-nav-responsive .dot-menu').on('click', function () {
        $('.side-nav-responsive .container .container').toggleClass('active');
    });

    // Client Slider 
    $('.client-slider').owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            1000: {
                items: 2
            }
        }
    });

    // Tabs Single Page
    $('.tab ul.tabs').addClass('active').find('> li:eq(0)').addClass('current');
    $('.tab ul.tabs li a').on('click', function (g) {
        var tab = $(this).closest('.tab'),
            index = $(this).closest('li').index();
        tab.find('ul.tabs > li').removeClass('current');
        $(this).closest('li').addClass('current');
        tab.find('.tab_content').find('div.tabs_item').not('div.tabs_item:eq(' + index + ')').slideUp();
        tab.find('.tab_content').find('div.tabs_item:eq(' + index + ')').slideDown();
        g.preventDefault();
    });

    // FAQ Accordion JS
    $('.accordion').find('.accordion-title').on('click', function () {
        // Adds Active Class
        $(this).toggleClass('active');
        // Expand or Collapse This Panel
        $(this).next().slideToggle('fast');
        // Hide The Other Panels
        $('.accordion-content').not($(this).next()).slideUp('fast');
        // Removes Active Class From Other Titles
        $('.accordion-title').not($(this)).removeClass('active');
    });

    // Popup Video
    $('.popup-btn').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });

    // Back To Top Js
    $('body').append('<div id="toTop" class="top-btn"><i class="bx bx-chevrons-up"></i></div>');
    $(window).on('scroll', function () {
        if ($(this).scrollTop() != 0) {
            $('#toTop').fadeIn();
        } else {
            $('#toTop').fadeOut();
        }
    });
    $('#toTop').on('click', function () {
        $('html, body').animate({scrollTop: 0}, 600);
        return false;
    });

    // WOW JS
    new WOW().init();

})(jQuery);
